module.exports = __webpack_public_path__ + "img/8.6bf234f8.png";